import Vue from "vue"

export const dialogMixin = {
  methods: {
    async $confirm(message, options = {}) {
      try {
        await Vue.dialog.confirm(message, { okText: 'Yes', cancelText: 'No', ...options })
        return true
      } catch (e) {
        return false
      }
    },

    async $confirmDelete(itemName = 'this item') {
      try {
        await Vue.dialog.confirm(`Delete ${itemName}?`, { okText: 'Delete', cancelText: 'Cancel' })
        return true
      } catch (e) {
        return false
      }
    },

    async $confirmSave(itemName = 'changes') {
      try {
        await Vue.dialog.confirm(`Save ${itemName}?`, { okText: 'Save', cancelText: 'Discard' })
        return true
      } catch (e) {
        return false
      }
    },

    async $confirmLeave() {
      try {
        await Vue.dialog.confirm('You have unsaved changes. Leave anyway?', { okText: 'Leave', cancelText: 'Stay' })
        return true
      } catch (e) {
        return false
      }
    },

    async $alert(message, options = {}) {
      try {
        await Vue.dialog.alert(message, { okText: 'OK', ...options })
        return true
      } catch (e) {
        return false
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/mixins/dialog.js